<app-page-header
  title="Benachrichtigungen"
  subtitle="Bleib über Aktivitäten und wichtige Updates informiert."
  icon="notifications_active"
  variant="gradient">
</app-page-header>

<div class="nlc-container nlc-notifications-wrapper nlc-slide-up">
  <ng-container *ngIf="(notifications$ | async) as notifications">
    <div *ngIf="notifications.length > 0; else noNotifications" class="nlc-notifications-list">
      <article
        *ngFor="let note of notifications.slice().reverse()"
        class="nlc-card nlc-card-hover nlc-notification-card"
        [ngClass]="{ unread: !note.isRead, read: note.isRead, 'nlc-card-clickable': !!note.link }"
        (mouseenter)="markAsRead(note)"
        [routerLink]="note.link || undefined"
        role="article"
        aria-label="Benachrichtigung"
      >
        <div class="nlc-notification-icon">
          <mat-icon>{{ note.isRead ? 'notifications' : 'notifications_active' }}</mat-icon>
        </div>
        <div class="nlc-notification-content">
          <h2 class="nlc-notification-title">
            {{ note.title || 'Benachrichtigung' }}
          </h2>
          <p class="nlc-notification-message">
            {{ note.message }}
          </p>
          <div class="nlc-notification-meta">
            <span class="nlc-notification-time" *ngIf="note.createdAt">
              {{ note.createdAt | date: 'short' }}
            </span>
            <span class="nlc-notification-status" [ngClass]="{ unread: !note.isRead, read: note.isRead }">
              {{ note.isRead ? 'Gelesen' : 'Ungelesen' }}
            </span>
            <button
              *ngIf="!note.isRead"
              mat-stroked-button
              color="primary"
              class="nlc-button nlc-button-secondary nlc-button-small nlc-mark-read-btn"
              (click)="onMarkAsRead($event, note)"
            >
              <mat-icon>done</mat-icon>
              Als gelesen markieren
            </button>
          </div>
        </div>
      </article>
    </div>
    <ng-template #noNotifications>
      <div class="nlc-card nlc-no-notifications nlc-fade-in">
        <div class="nlc-empty-icon">
          <mat-icon>notifications_off</mat-icon>
        </div>
        <div>
          <h2 class="nlc-heading-3">Alles erledigt!</h2>
          <p class="nlc-body-secondary">
            Du hast aktuell keine Benachrichtigungen.
          </p>
        </div>
      </div>
    </ng-template>
  </ng-container>
</div>
